import HundredBricksAPIError from '../../../HundredBricksAPIError';
class PaymentPlanError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PaymentPlanError', ...args);
    }
}
export default PaymentPlanError;
